export default __webpack_public_path__ + "media/color/snt-2ee4ea2f.svg";